var _jsxFileName = "/home/christian/DEV/workspace/crossbuilders/form-library/src/lib/components/structure/FormRow/index.jsx";
import React from 'react';
import PropTypes from 'prop-types';
import '../../../assets/scss/3_components/_form-row.scss';
export default function FormRow(props) {
  var className = props.className,
    errorClass = props.errorClass,
    hasErrors = props.hasErrors,
    children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: hasErrors ? "".concat(className, " ").concat(errorClass) : className,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 9
    }
  }, children);
}
FormRow.propTypes = {
  className: PropTypes.string,
  errorClass: PropTypes.string,
  hasErrors: PropTypes.bool
};
FormRow.defaultProps = {
  className: 'form-row',
  errorClass: 'form-row--has-errors',
  hasErrors: false
};